// extracted by mini-css-extract-plugin
export const homeUsps = "HomeUsps-module--home-usps--5UPpe";
export const homeUsps__title = "HomeUsps-module--home-usps__title--1l_b7";
export const homeUsps__usp = "HomeUsps-module--home-usps__usp--284cc";
export const homeUsps__uspTitle = "HomeUsps-module--home-usps__usp-title--2CE4D";
export const homeUsps__uspText = "HomeUsps-module--home-usps__usp-text--2JB0c";